import isOnLocalhost from '@client-shared/utils/is-on-localhost'
import { getAjaxErrorMessage, getAxiosCustomData } from '@client-shared/utils/raygun-axios-custom-data.js'
import axios from 'axios'

export default ({ error, tags, customData }) => {
  // intentionally aborted requests (AbortController / AbortSignal.timeout) are never reported
  if (axios.isCancel(error)) {
    if (isOnLocalhost) {
      console.log('localhost -> Request was aborted.', error.message)
    }

    return
  }

  if (isOnLocalhost) {
    console.log('sendRaygun', {
      error,
      tags,
      customData,
    })
  }

  if (!window.rg4js) {
    return
  }

  if (!axios.isAxiosError(error)) {
    window.rg4js('send', {
      error,
      tags,
      customData,
    })

    return
  }

  window.rg4js('send', {
    error,
    tags: [
      ...(tags || []),
      'axios',
      `status:${error.response?.status ?? error.code}`,
    ],
    customData: {
      ajaxErrorMessage: getAjaxErrorMessage(error),
      axios: getAxiosCustomData(error),
      ...(customData ? { context: customData } : {}),
    },
  })
}
